import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import { storesListing, privacyPolicy, regulations, contact, blog } from './../../dictionaries/navigation';
import ModalCookies from '../modalcookies';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

interface FooterProps {
  openCookiesModal: () => void;
}

const Footer: React.FC<FooterProps> = ({ openCookiesModal }) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const openCookies = () => {
    setShowModal(true);
  };

  return (
    <div>
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <h4>Linki</h4>
          <ul>
            <li><Link to={storesListing} onClick={scrollToTop}>Sklepy</Link></li>
            <li><Link to={blog} onClick={scrollToTop}>Blog</Link></li>
            <li><Link to={contact} onClick={scrollToTop}>Kontakt</Link></li>
            <li><Link to={privacyPolicy} onClick={scrollToTop}>Polityka Prywatności</Link></li>
            <li><Link to={regulations} onClick={scrollToTop}>Regulamin</Link></li>
            <li><Link to="#" onClick={(e) => { e.preventDefault(); openCookiesModal(); }}>Ustawienia cookies</Link></li>
          </ul>
        </div>
        <div className="footer-info">
          <p>&copy; {new Date().getFullYear()} Szafa Polska. Wszystkie prawa zastrzeżone.</p>
          <p>Część linków i kodów rabatowych to linki afiliacyjne – mogę otrzymać prowizję, jeśli z nich skorzystasz.</p>
        </div>
      </div>

    </footer>
    </div>
  );
};

export default Footer;
